export const actionsCreator = ({ setState }) => ({
  SET_IS_PINNED: (isPinned) => {
    setState({ isPinned });
  }
});

export const eventHeaderActions = actionsCreator({});
